import React from 'react'
import {connect} from 'react-redux'

import Component from '../components/help'

class Container extends React.Component {

  state = {
    isChatDisabled: true,
  }

  componentWillMount() {
    this.updateIsChatDisabled()
    this.chatTimer = setInterval(() => this.updateIsChatDisabled(), 5000)
  }

  componentWillUnmount() {
    clearInterval(this.chatTimer)
  }

  updateIsChatDisabled = () => {
    this.setState({isChatDisabled: this.isChatDisabled()})
  }

  isChatDisabled = () => {
    const LC_API = window.LC_API
    if (!LC_API) return true

    return !LC_API.agents_are_available()
  }

  render() {
    return <Component {...this.props} isChatDisabled={this.state.isChatDisabled}/>
  }
}


const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/help/containers/help.js